import { Injectable } from '@angular/core';
import { HttpClient } from '../../shared/wrappers/HttpClient';
import { Company } from "../../models/billing-letter/Company.model";
import { CompanyGroup } from "../../models/billing-letter/CompanyGroup.model";
import { CompanyFinancial } from '../../models/project/CompanyFinancial.model';

@Injectable()
export class CompanyService {
    private endPoint: String = "/companies";

    constructor(private httpClient: HttpClient) { }

    async getAll(): Promise<Company[]> {
        let project = '_id,name,cnpj,active';
        let filter = 'onlyCustomer=true';
        const companies = (await this.httpClient.get(`${this.endPoint}?project=${project}&filter=${filter}`)).companies.map(company => {
            return new Company(company);
        });

        return companies;
    }

    async getCompaniesByGroupId(groupId): Promise<Company[]> {
        const companies = (await this.httpClient.get(`${this.endPoint}/group/${groupId}/companies`)).companies.map(company => {
            return new Company(company);
        });
        return companies;
    }

    async getAllCompanyGroups(active?: boolean): Promise<CompanyGroup[]> {
        let url = `${this.endPoint}/group`;

        if(active != undefined) {
            url += `?filter=active=${active}`;
        }

        const companyGroups = (await this.httpClient.get(url)).groups.map(group => {
            return new CompanyGroup(group);
        });
        return companyGroups;
    }

    async getCompanyGroupsWithCustomer() {
        return await this.httpClient.get(`${this.endPoint}/group/with-customer`)
    }

    randomPixKeyValid(pixKey: String){
        return pixKey.length === 32
    }

    async getCompaniesByGroupIdForProjectsCost(groupId): Promise<CompanyFinancial[]> {
        const companies = (await this.httpClient.get(`${this.endPoint}/group/${groupId}/companies`)).companies.map(company => {
            return new CompanyFinancial(company);
        });
        return companies;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/billing-letter/company.service.ts